module.exports = __webpack_public_path__ + "static/media/logo-skillacademy-left.6060fbc4.png";